/**
 * Module dependencies.
 */

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PieChartOutlined } from '@ant-design/icons';
import { Outlet } from 'react-router-dom';
import { Dashboard } from './dashboard';
import { appRoutes } from 'app/routes';
import { compileMenu } from 'app/core/utils/menu';
import { BsPhone } from 'react-icons/bs';
import { TbDeviceMobileCog } from 'react-icons/tb';

/**
 * Export `SkinTables` component.
 */

export function SkinTables(): JSX.Element {
  const [translate] = useTranslation();
  const items = useMemo(
    () =>
      compileMenu([
        {
          key: '1',
          pathname: appRoutes.dashboard.tables.base,
          icon: <PieChartOutlined />,
          label: translate('tables.menu.overview')
        },
        {
          key: '2',
          pathname: appRoutes.dashboard.tables.dialCodes,
          icon: <BsPhone />,
          label: translate('tables.menu.dialCodes')
        },
        {
          key: '3',
          pathname: appRoutes.dashboard.tables.devices,
          icon: <TbDeviceMobileCog />,
          label: translate('tables.menu.devices')
        }
      ]),
    [translate]
  );

  return (
    <Dashboard menu={items}>
      <Outlet />
    </Dashboard>
  );
}
